import { compose, map, propOr } from 'ramda';

import { compact, path } from '../../../helpers/compact';

export const relatedPushs = compose(
  compact,
  map(path('push.id')),
  propOr([], 'pushs')
);
